import React from "react";
import { MdOutlineFileDownload } from "react-icons/md";
import { isMobileDevice } from "../../utils/utils";
import { handleDownloadAppClickedEvent } from "../../utils/helperEventFunctions";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import useStore from "../../store/UseStore";

const TrialWithDownloadCTA = ({
  ctaClassName,
  desktopStatus,
  mobileStatus,
  deepLink,
  onSection,
}) => {
  const { setOpenQRModal } = useStore();
  const router = useRouter();
  const firebaseUID = useSelector((state) => state.currentUser.firebaseUID);
  const sourceScreen = router?.query ? router?.asPath : router?.pathname;
  return (
    <div className="relative">
      <button
        onClick={() => {
          handleDownloadAppClickedEvent({
            firebaseUID,
            desktopStatus,
            mobileStatus,
            sourceScreen,
            anonymousId: "",
          });
          if (!isMobileDevice()) {
            setOpenQRModal({
              open: true,
              fromSection: onSection,
            });
          } else {
            window.location.href = deepLink;
          }
        }}
        className={`relative z-20 !text-[14px] shiny-button !font-lexend bg-gradient-to-r from-[#AF30BF] to-[#5E30BF] w-full !py-3 !text-white flex items-center justify-center gap-x-2 font-medium !border !border-purple-400 rounded-lg ${
          ctaClassName || ""
        }`}
      >
        <MdOutlineFileDownload className="!text-[24px]" />{" "}
        <span className="font-lexend">Download Seekho App</span>
      </button>
      {/* <h6
        className={`absolute w-full -top-8 font-lexend text-[12px] bg-[#61543d] bg-opacity-40 text-white/75 font-medium text-center border-t border-r border-l border-[#61543d] rounded-t-lg !pt-2 !pb-8 lg:text-[16px] lg:!pt-3 lg:!pb-10 lg:-top-10 ${
          textClassName || ""
        }`}
      >
        7 days trial for just ₹1
      </h6> */}
    </div>
  );
};

export default TrialWithDownloadCTA;
